import { Grid, Typography } from "@mui/material";
import { Container, Stack } from "@mui/system";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { topSkillApi } from "../../API/Api";
import BrowseSkillItem from "./BrowseSkillItem";

const BrowseSkill = ({ id }) => {
  const [skillsData, setSkillsData] = useState([]);

  useEffect(() => {
    fetch(
      `https://ghorami.com/profile/login/api_webland/top_skill.php?eid=${id}`
    )
      .then((res) => res.json())
      .then((result) => {
        setSkillsData(result);
      })
      .catch((error) => {
        console.log("fetch skills Failed", error);
      });
  }, []);

  return (
    <Container sx={{ mt: "40px", mb: "40px" }}>
      <Stack justifyContent="center" alignItems="center">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "26pt", md: "34pt" },
            background: "linear-gradient(to right, #00C9A7, #0074E4)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "0.5px",
          }}
        >
          Browse Skills and Locations
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 500,
            fontSize: { xs: "13pt", md: "15pt" },
            color: "#9E9E9E",
            maxWidth: "600px",
          }}
        >
          Look for the best meeting your skills and most preferred locations
        </Typography>
      </Stack>
      <Grid container spacing={2}>
        {skillsData.map((element) => (
          <Grid item xs={6} sm={4} md={2} key={element.refer}>
            <BrowseSkillItem skillsData={element} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default BrowseSkill;
